// A native <select> cell stops pointerdown from reaching ReactGrid (so its
// dropdown can open), which means clicking it never updates the grid's focused
// cell — arrow keys and Delete afterwards target the wrong cell. This reducer
// syncs the grid to that cell.
//
// It mirrors ReactGrid's OWN single-cell focus (its internal `focusLocation`/`y`):
// it sets focusedLocation AND the matching single-cell selectedRange together.
// Setting only focusedLocation leaves selectedRanges stale and splits the
// highlight — focus border on the new cell, selection fill stuck on the old one.
export const buildFocusedCellState = (state: any, rowIdx: number, colIdx: number): any => {
  const cellMatrix = state?.cellMatrix;
  const row = cellMatrix?.rows?.[rowIdx];
  const column = cellMatrix?.columns?.[colIdx];
  if (!row || !column) return state;

  const location = cellMatrix.getLocationById(row.rowId, column.columnId);

  return {
    ...state,
    focusedLocation: location,
    selectedRanges: [cellMatrix.getRange(location, location)],
    activeSelectedRangeIdx: 0,
    selectedIndexes: [],
    selectedIds: [],
    selectionMode: 'range',
    currentlyEditedCell: undefined,
    contextMenuPosition: { top: -1, left: -1 }
  };
};
